import { Injectable } from '@angular/core';
import { IRosterOpsHost } from './roster-member-ops.service';

export interface IRosterSelectionHost extends IRosterOpsHost {
  rosterMemberCheckedCounter: number;
  // teamsData, selectedRosterMembers, selectedFilterMbr, membersDetails4NewTeam,
  // filterData, searchby, selectedInvitation are already in IRosterOpsHost
}

@Injectable({ providedIn: 'root' })
export class RosterSelectionService {

  // ── toggle individual user in selection array ──────────────────────────────

  toggleSelectedUser(user: any, host: IRosterSelectionHost): void {
    const index = host.selectedRosterMembers.findIndex(u => u.id === user.id);
    if (index > -1) {
      host.selectedRosterMembers.splice(index, 1);
    } else {
      host.selectedRosterMembers.push(user);
    }
  }

  // ── check/uncheck a single member ─────────────────────────────────────────

  memberChecked(record: any, host: IRosterSelectionHost): void {
    let checkedCounter = 0;
    const getTotalChecked = () => {
      const checkboxes = document.querySelectorAll('.orgs_team__branch_title_name input');
      checkedCounter = 0;
      checkboxes.forEach((checkbox: any) => {
        if (checkbox.checked) checkedCounter += 1;
      });
      if (checkedCounter !== 0) {
        host.modalSvc.membersDetails4NewTeam = record;
      } else {
        host.modalSvc.membersDetails4NewTeam = null;
      }
    };
    this.toggleSelectedUser(record, host);
    if (record['checked']) {
      record.checked = !record.checked;
      host.selectedFilterMbr = host.selectedFilterMbr.filter((mbr: any) => mbr.id !== record.id);
      host.selectedRosterMembers = host.selectedRosterMembers.filter((mbr: any) => mbr.id !== record.id);
      getTotalChecked();
    } else {
      getTotalChecked();
      record['checked'] = true;
    }
    host.rosterMemberCheckedCounter = checkedCounter;
    if (host.filterData) {
      host.selectedFilterMbr.push(record);
    }
  }

  // ── select / deselect all roster members ──────────────────────────────────

  selectAllRoaster(checked: boolean, host: IRosterSelectionHost): void {
    const checkboxes = document.querySelectorAll('.orgs_team__branch_title_name input');
    if (checked) {
      checkboxes.forEach((item: any) => { item.checked = true; });
      host.modalSvc.membersDetails4NewTeam = host.teamsData?.members[host.teamsData?.members.length - 1];
      host.modalSvc.membersDetails4NewTeam.teams_names = {};
      let data;
      if (host.searchby === 'invitation' && host.modalSvc.selectedInvitation !== 'Select Invitation') {
        data = host.filterData;
      } else {
        data = host.teamsData.members;
      }
      data.forEach((mem) => { mem['checked'] = true; });
      host.selectedRosterMembers = [...data];
    } else {
      checkboxes.forEach((item: any) => { item.checked = false; });
      let data;
      if (host.searchby === 'invitation' && host.modalSvc.selectedInvitation !== 'Select Invitation') {
        data = host.filterData;
      } else {
        data = host.teamsData?.members;
      }
      data?.forEach((mem) => { mem['checked'] = false; });
    }
  }
}
